export const categories = [
  {
    id: 'feature-intro',
    name: '功能介绍',
    slug: 'feature-intro',
    description: '全面了解雏鸟app的各项核心功能与特色亮点',
    icon: 'ri-smartphone-line',
    color: 'primary',
  },
  {
    id: 'tutorial',
    name: '使用教程',
    slug: 'tutorial',
    description: '从注册到精通，手把手教你玩转雏鸟app',
    icon: 'ri-book-open-line',
    color: 'accent',
  },
  {
    id: 'download',
    name: '下载指南',
    slug: 'download',
    description: '多平台下载方式与安装指引，快速获取雏鸟app',
    icon: 'ri-download-cloud-line',
    color: 'secondary',
  },
  {
    id: 'community',
    name: '社区故事',
    slug: 'community',
    description: '听听雏鸟用户们的真实故事与成长经历',
    icon: 'ri-user-heart-line',
    color: 'primary',
  },
  {
    id: 'faq',
    name: '常见问题',
    slug: 'faq',
    description: '使用过程中遇到问题？这里有你想要的答案',
    icon: 'ri-question-answer-line',
    color: 'accent',
  },
];

export const articles = [
  {
    id: 'article-1',
    categorySlug: 'feature-intro',
    title: '兴趣匹配：找到志同道合的灵魂伙伴',
    summary: '雏鸟app通过智能算法为你推荐兴趣爱好相近的用户，让你快速找到真正聊得来的朋友。',
    content: `兴趣匹配是雏鸟app最受欢迎的核心功能之一。我们深知，在茫茫人海中找到真正懂你的人并不容易。

雏鸟app采用了先进的多维兴趣匹配算法，从音乐品味、电影偏好、阅读习惯、运动爱好、旅行风格等十余个维度出发，为用户精准匹配志趣相投的伙伴。

当你首次注册雏鸟app时，系统会引导你完成一份精心设计的兴趣问卷。这份问卷涵盖了生活的方方面面，不仅包括你喜欢的音乐类型、电影风格，还会了解你的生活方式、价值观和社交偏好。

完成问卷后，雏鸟app会立即为你生成专属的兴趣画像。基于这个画像，系统会在社区中为你推荐匹配度最高的用户。匹配度以百分比形式展示，让你直观了解与潜在好友的契合程度。

除了被动推荐，你还可以主动使用「发现」功能，根据特定兴趣标签搜索用户。比如，如果你是一个热爱户外徒步的人，可以搜索同样喜欢户外运动的用户，发起聊天邀请。

雏鸟app的兴趣匹配功能不仅仅停留在线上社交。平台定期举办各种主题的线下活动，为匹配度高的用户群体创造面对面交流的机会。从读书会到登山活动，从音乐节到手工工作坊，每一次线下相遇都可能成为一段美好友谊的开始。`,
    imageSeq: 'article-interest-match',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20young%20people%20connecting%20through%20shared%20interests%20with%20floating%20interest%20icons%20warm%20coral%20and%20teal%20color%20palette%20clean%20composition%20abstract%20geometric%20elements%20youthful%20vibrant%20energy&width=800&height=500&seq=article-1-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Wide%20editorial%20illustration%20of%20diverse%20young%20people%20forming%20meaningful%20connections%20through%20shared%20interests%20warm%20coral%20teal%20amber%20color%20palette%20minimal%20modern%20design%20abstract%20organic%20shapes%20soft%20gradients&width=1200&height=600&seq=article-1-detail&orientation=landscape',
    readCount: 12850,
    publishDate: '2026-07-20',
    author: '雏鸟编辑部',
    relatedArticles: ['article-2', 'article-5', 'article-8'],
  },
  {
    id: 'article-2',
    categorySlug: 'feature-intro',
    title: '内容分享：记录成长每一步',
    summary: '用图文、短视频记录你的生活点滴，与社区成员分享你的成长故事与精彩瞬间。',
    content: `在雏鸟app上，每一位用户都是内容的创造者。内容分享功能让你可以随时记录生活中的精彩瞬间，无论是第一次独自旅行、学会一道新菜、还是读完一本好书，都可以通过图文或短视频的形式与社区分享。

雏鸟app内置了强大的内容编辑器，支持文字排版、图片滤镜、贴纸装饰等多种功能。即使是编辑小白，也能轻松创作出精美的内容。

更特别的是，雏鸟app引入了「成长日记」概念。你可以选择将某些内容标记为成长日记，系统会自动为你生成时间线，帮助你回顾自己的成长轨迹。一年后再回头看，你会发现自己的变化有多大。

社区成员可以对你的分享进行点赞、评论和转发。优质内容还会被推荐到首页的「精选」栏目，让更多人看到你的精彩生活。雏鸟app鼓励正向互动，社区氛围友善温暖，每个人都能在这里找到归属感。

此外，雏鸟app还提供了「话题挑战」功能。每周平台会推出不同的创作主题，参与挑战并发布相关内容，就有机会获得官方推荐和精美周边礼品。这不仅激发了用户的创作热情，也让社区内容更加丰富多彩。`,
    imageSeq: 'article-content-share',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20young%20person%20creating%20and%20sharing%20content%20on%20phone%20with%20photo%20grid%20and%20diary%20elements%20warm%20coral%20teal%20color%20palette%20clean%20simple%20design%20youthful%20energy&width=800&height=500&seq=article-2-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20creative%20content%20creation%20and%20sharing%20among%20young%20people%20with%20photos%20videos%20and%20growth%20journal%20elements%20warm%20coral%20teal%20amber%20palette%20minimal%20modern%20abstract%20shapes&width=1200&height=600&seq=article-2-detail&orientation=landscape',
    readCount: 9650,
    publishDate: '2026-07-15',
    author: '雏鸟编辑部',
    relatedArticles: ['article-1', 'article-4', 'article-7'],
  },
  {
    id: 'article-3',
    categorySlug: 'feature-intro',
    title: '社区互动：多元圈子等你加入',
    summary: '加入兴趣圈子，参与话题讨论，在雏鸟app中找到属于你的社群归属感。',
    content: `雏鸟app的社区互动功能是平台的灵魂所在。在这里，你可以加入各种各样的兴趣圈子，与同好们畅聊你热爱的一切。

目前雏鸟app上已经创建了超过500个兴趣圈子，涵盖音乐、电影、读书、运动、美食、旅行、摄影、绘画、编程、游戏等数十个领域。无论你的爱好多么小众，总有一个圈子在等着你。

每个圈子都有自己的专属空间，包括话题讨论区、活动公告板、资源共享库等模块。圈子管理员会定期组织线上活动，比如读书圈的「每月共读」、摄影圈的「主题拍摄挑战」、音乐圈的「歌单交换」等等。

雏鸟app的社区互动注重质量而非数量。我们设计了一套「友善度」评价系统，鼓励用户进行有建设性的交流。社区氛围由所有成员共同维护，让每个人都能在安全、舒适的环境中表达自己。

此外，雏鸟app还推出了「成长伙伴」功能。你可以与社区中的好友结成成长伙伴关系，互相监督目标进度、分享学习资源、为对方加油打气。这种一对一的深度互动，让社交不再停留在表面，而是真正促进彼此的成长。`,
    imageSeq: 'article-community',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20diverse%20community%20circles%20and%20groups%20of%20young%20people%20interacting%20with%20floating%20interest%20bubbles%20warm%20coral%20teal%20color%20palette%20clean%20composition&width=800&height=500&seq=article-3-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20vibrant%20online%20communities%20and%20interest%20groups%20with%20diverse%20young%20people%20engaging%20in%20discussions%20and%20activities%20warm%20coral%20teal%20amber%20palette%20abstract%20geometric%20design&width=1200&height=600&seq=article-3-detail&orientation=landscape',
    readCount: 8230,
    publishDate: '2026-07-10',
    author: '雏鸟编辑部',
    relatedArticles: ['article-1', 'article-6', 'article-9'],
  },
  {
    id: 'article-4',
    categorySlug: 'tutorial',
    title: '雏鸟app注册与账号设置完整教程',
    summary: '从下载应用到完成注册，再到个性化账号设置，一步步带你完成雏鸟app的初次使用。',
    content: `注册雏鸟app非常简单，只需要几分钟就能完成。本教程将带你一步步走完整个流程。

第一步：下载应用
打开手机应用商店（iOS用户打开App Store，安卓用户打开应用宝或各大应用市场），搜索「雏鸟」，找到雏鸟app官方应用并下载安装。

第二步：选择注册方式
打开雏鸟app后，你可以选择手机号注册或微信一键登录。推荐使用手机号注册，这样可以更好地保护你的账号安全。输入手机号后，点击「获取验证码」，将收到的6位验证码填入即可。

第三步：设置个人资料
完成验证后，你需要设置一些基本资料，包括：
- 昵称：选择一个你喜欢的名字，后续可以修改
- 头像：上传一张代表你的照片
- 生日：用于年龄验证和内容推荐
- 性别：选填，用于更好的兴趣匹配

第四步：完成兴趣问卷
这是雏鸟app注册流程中最重要的一步。系统会引导你完成一份兴趣问卷，大约需要5-8分钟。请认真填写，因为这将直接影响后续的好友推荐质量。

第五步：探索雏鸟app
完成注册后，你会看到雏鸟app的主界面。顶部是「动态」信息流，底部导航栏包括首页、发现、发布、消息和我的五个入口。花几分钟熟悉一下界面布局，然后就可以开始探索了！`,
    imageSeq: 'article-register',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20a%20young%20person%20registering%20on%20a%20mobile%20app%20with%20step%20by%20step%20onboarding%20screens%20warm%20coral%20teal%20color%20palette%20clean%20simple%20design&width=800&height=500&seq=article-4-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20mobile%20app%20registration%20and%20onboarding%20process%20with%20young%20user%20completing%20profile%20steps%20warm%20coral%20teal%20amber%20palette%20minimal%20modern%20abstract%20design&width=1200&height=600&seq=article-4-detail&orientation=landscape',
    readCount: 15680,
    publishDate: '2026-07-25',
    author: '雏鸟编辑部',
    relatedArticles: ['article-5', 'article-7', 'article-8'],
  },
  {
    id: 'article-5',
    categorySlug: 'tutorial',
    title: '如何高效使用雏鸟app的匹配功能',
    summary: '掌握这些技巧，让雏鸟app帮你找到更多志同道合的朋友，提升社交效率。',
    content: `兴趣匹配是雏鸟app的核心功能，用好了它，你的社交体验会有质的飞跃。以下是一些实用技巧。

1. 完善你的兴趣画像
匹配算法的准确度很大程度上取决于你提供的兴趣数据。建议花时间完善个人资料中的每一个兴趣选项，不要跳过任何一项。越详细的数据，匹配结果越精准。

2. 定期更新兴趣标签
人的兴趣会随着时间变化，雏鸟app允许你随时更新兴趣标签。建议每个月花几分钟回顾并更新一次，让系统始终了解最新的你。

3. 善用「发现」功能
除了被动等待推荐，主动出击也很重要。使用发现功能中的筛选条件，可以根据年龄、地区、兴趣等多个维度搜索用户。

4. 认真填写个人简介
一个好的个人简介能让匹配到的用户快速了解你。建议包含你的核心兴趣、目前在做的有趣事情、以及你希望在雏鸟app上找到什么样的朋友。

5. 积极参与圈子活动
加入与你兴趣相关的圈子，积极参与讨论和活动。圈子是拓展社交网络的最佳场所，很多深厚的友谊都从这里开始。

6. 保持活跃
系统会更倾向于推荐活跃用户。定期登录、发布内容、参与讨论，让你的账号保持活跃状态，获得更多曝光机会。`,
    imageSeq: 'article-match-tips',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20smart%20matching%20algorithm%20connecting%20compatible%20young%20people%20with%20floating%20match%20percentage%20badges%20warm%20coral%20teal%20color%20palette%20clean%20design&width=800&height=500&seq=article-5-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20efficient%20social%20matching%20and%20connection%20with%20young%20people%20discovering%20compatible%20friends%20through%20smart%20algorithm%20warm%20coral%20teal%20amber%20palette%20abstract%20shapes&width=1200&height=600&seq=article-5-detail&orientation=landscape',
    readCount: 11230,
    publishDate: '2026-07-18',
    author: '雏鸟编辑部',
    relatedArticles: ['article-1', 'article-3', 'article-4'],
  },
  {
    id: 'article-6',
    categorySlug: 'tutorial',
    title: '雏鸟app隐私设置与安全指南',
    summary: '了解雏鸟app的隐私保护机制，学会设置个人隐私选项，安全放心地享受社交乐趣。',
    content: `在雏鸟app上，你的隐私和安全是我们的首要关切。本指南将帮助你了解并设置好各项隐私保护选项。

隐私设置入口
打开雏鸟app，进入「我的」页面，点击右上角的设置图标，选择「隐私设置」即可进入。

可见性控制
你可以精确控制哪些信息对其他用户可见：
- 个人资料可见范围：所有人/仅好友/仅自己
- 在线状态：显示/隐藏
- 最后活跃时间：显示/隐藏
- 位置信息：精确/模糊/隐藏

互动权限
- 谁可以给我发消息：所有人/仅好友/仅匹配用户
- 谁可以查看我的动态：所有人/仅好友/仅自己
- 谁可以邀请我加入圈子：所有人/仅好友
- 评论权限：所有人/仅好友

黑名单与举报
如果遇到骚扰或不友善行为，你可以：
- 将用户加入黑名单，对方将无法与你互动
- 举报违规内容或用户，我们的审核团队会在24小时内处理

数据安全
雏鸟app采用业界领先的加密技术保护你的数据。所有敏感信息在传输和存储过程中都经过加密处理。我们承诺不会将你的个人数据出售给任何第三方。`,
    imageSeq: 'article-privacy',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20privacy%20and%20security%20protection%20with%20shield%20and%20lock%20symbols%20surrounding%20a%20young%20person%20on%20phone%20warm%20coral%20teal%20color%20palette%20clean%20design&width=800&height=500&seq=article-6-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20digital%20privacy%20and%20data%20security%20with%20protective%20elements%20around%20young%20user%20on%20social%20platform%20warm%20coral%20teal%20amber%20palette%20minimal%20abstract%20design&width=1200&height=600&seq=article-6-detail&orientation=landscape',
    readCount: 7890,
    publishDate: '2026-07-05',
    author: '雏鸟编辑部',
    relatedArticles: ['article-4', 'article-8', 'article-10'],
  },
  {
    id: 'article-7',
    categorySlug: 'download',
    title: 'iOS用户下载安装雏鸟app指南',
    summary: '在App Store中搜索并下载雏鸟app，支持iOS 14及以上系统，完整安装步骤说明。',
    content: `如果你使用的是iPhone或iPad，按照以下步骤即可下载安装雏鸟app。

系统要求
雏鸟app支持iOS 14.0及以上版本，兼容iPhone、iPad和iPod touch。建议使用最新版iOS系统以获得最佳体验。

下载步骤
1. 打开App Store应用
2. 点击右下角的「搜索」标签
3. 在搜索框中输入「雏鸟」或「雏鸟app」
4. 在搜索结果中找到雏鸟app（开发者：雏鸟科技）
5. 点击「获取」按钮，使用Face ID、Touch ID或Apple ID密码确认
6. 等待下载和安装完成
7. 点击主屏幕上的雏鸟app图标即可打开

首次启动
第一次打开雏鸟app时，系统会请求以下权限：
- 通知权限：建议开启，不错过好友消息
- 相机权限：用于拍照分享和视频通话
- 相册权限：用于上传头像和分享图片
- 位置权限：用于附近的人功能（可选）

建议全部开启以获得完整体验。如果暂时不想开启，也可以在后续通过「设置 > 雏鸟」中重新配置。

更新应用
雏鸟app会定期推出新版本，建议开启App Store的自动更新功能，确保始终使用最新版本。`,
    imageSeq: 'article-ios-download',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20an%20iPhone%20with%20app%20store%20download%20screen%20showing%20a%20social%20app%20warm%20coral%20teal%20color%20palette%20clean%20simple%20design&width=800&height=500&seq=article-7-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20iOS%20app%20download%20and%20installation%20process%20with%20iPhone%20displaying%20app%20store%20interface%20warm%20coral%20teal%20amber%20palette%20minimal%20modern%20abstract%20design&width=1200&height=600&seq=article-7-detail&orientation=landscape',
    readCount: 14200,
    publishDate: '2026-07-28',
    author: '雏鸟编辑部',
    relatedArticles: ['article-8', 'article-4', 'article-10'],
  },
  {
    id: 'article-8',
    categorySlug: 'download',
    title: '安卓用户下载安装雏鸟app指南',
    summary: '在各大安卓应用商店中搜索雏鸟app，支持Android 8.0及以上系统，安全下载完整指南。',
    content: `安卓用户可以通过多个渠道下载雏鸟app。本指南将详细介绍各个下载方式。

系统要求
雏鸟app支持Android 8.0及以上版本。建议手机运行内存不低于3GB，存储空间不低于200MB。

官方推荐下载渠道
1. 华为应用市场：搜索「雏鸟」
2. 小米应用商店：搜索「雏鸟」
3. OPPO软件商店：搜索「雏鸟」
4. vivo应用商店：搜索「雏鸟」
5. 应用宝：搜索「雏鸟」
6. 酷安：搜索「雏鸟」

下载步骤（以应用宝为例）
1. 打开应用宝
2. 在顶部搜索栏输入「雏鸟」或「雏鸟app」
3. 确认开发者为「雏鸟科技」
4. 点击「下载」按钮
5. 等待下载完成后点击「安装」
6. 安装完成后点击「打开」即可

权限说明
首次启动时会请求以下权限：
- 存储权限：用于缓存图片和保存文件
- 相机权限：用于拍照和视频功能
- 位置权限：用于附近的人功能
- 通知权限：用于消息推送

安全提示
请务必通过官方渠道下载雏鸟app，不要从不明来源的网站下载APK文件，以免安装到恶意篡改的版本。`,
    imageSeq: 'article-android-download',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20an%20Android%20phone%20with%20app%20store%20download%20screen%20showing%20a%20social%20app%20warm%20coral%20teal%20color%20palette%20clean%20simple%20design&width=800&height=500&seq=article-8-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20Android%20app%20download%20and%20installation%20with%20phone%20displaying%20multiple%20app%20stores%20warm%20coral%20teal%20amber%20palette%20minimal%20modern%20abstract%20design&width=1200&height=600&seq=article-8-detail&orientation=landscape',
    readCount: 13650,
    publishDate: '2026-07-28',
    author: '雏鸟编辑部',
    relatedArticles: ['article-7', 'article-4', 'article-10'],
  },
  {
    id: 'article-9',
    categorySlug: 'community',
    title: '从陌生人到挚友：雏鸟用户小林的真实故事',
    summary: '一位雏鸟app用户的真实经历分享，从孤独到拥有温暖社群，雏鸟改变了他的生活。',
    content: `小林是一名刚毕业来到大城市工作的年轻人。初来乍到，没有朋友，每天两点一线的生活让他感到格外孤独。

“那时候每天下班回到出租屋，连个说话的人都没有。”小林回忆道，“周末更难过，看着朋友圈里别人都在聚会，我却只能在屋里刷手机。”

一次偶然的机会，小林在应用商店看到了雏鸟app的介绍，被「找到志同道合的朋友」这句话打动，便下载试了试。

完成注册和兴趣问卷后，系统为他推荐了几位匹配度在85%以上的用户。小林鼓起勇气给其中一位发了消息。让他意外的是，对方很快回复了，两人发现都喜欢独立音乐和文艺电影，聊得非常投机。

通过这位新朋友，小林被拉进了一个音乐爱好者圈子。在那里，他认识了更多同好。从线上聊天到线下见面，从一起看演出到一起玩音乐，小林的生活变得越来越丰富。

“加入雏鸟app半年后，我的周末几乎排满了活动。”小林笑着说，“最让我感动的是，有一次我生病发烧，圈子里认识的朋友专门来看我，还带了药和粥。那种被人在乎的感觉真的很温暖。”

现在，小林已经成为了音乐圈子的管理员之一，定期组织线下活动。他说：“雏鸟app不只是帮我找到了朋友，更让我在这座大城市里找到了家的感觉。”`,
    imageSeq: 'article-story-xiaolin',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20a%20young%20person%20finding%20friendship%20and%20community%20in%20a%20big%20city%20with%20warm%20connection%20elements%20warm%20coral%20teal%20color%20palette%20clean%20design&width=800&height=500&seq=article-9-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20heartwarming%20story%20of%20friendship%20and%20belonging%20in%20urban%20life%20with%20young%20people%20connecting%20through%20shared%20interests%20warm%20coral%20teal%20amber%20palette%20abstract%20design&width=1200&height=600&seq=article-9-detail&orientation=landscape',
    readCount: 21500,
    publishDate: '2026-07-12',
    author: '雏鸟编辑部',
    relatedArticles: ['article-1', 'article-3', 'article-5'],
  },
  {
    id: 'article-10',
    categorySlug: 'faq',
    title: '雏鸟app常见问题汇总（2026年7月更新）',
    summary: '收集了用户最常问的20个问题，涵盖注册、使用、付费、安全等各方面。',
    content: `Q1：雏鸟app是免费的吗？
A：雏鸟app基础功能完全免费，包括注册、匹配、聊天、发布动态等。部分高级功能（如查看谁访问了你的主页、超级匹配等）需要开通会员。

Q2：如何注销账号？
A：进入「我的 > 设置 > 账号管理 > 注销账号」，按照提示操作即可。注销后所有数据将被永久删除。

Q3：忘记密码怎么办？
A：在登录页面点击「忘记密码」，输入注册手机号，按照短信提示重置密码。

Q4：可以同时在多个设备登录吗？
A：目前支持手机和iPad同时在线，但不支持多台手机同时登录。

Q5：发布的动态可以修改吗？
A：文字内容可以随时编辑修改，图片和视频发布后不支持替换。

Q6：如何举报违规用户？
A：进入该用户主页，点击右上角「...」，选择「举报」，提交举报原因即可。

Q7：匹配度是如何计算的？
A：匹配度基于你和对方的兴趣标签重合度、互动频率、地理位置等多个因素综合计算。

Q8：雏鸟app收集哪些个人信息？
A：我们仅收集必要的账号信息和你在使用过程中主动提供的内容，详细信息请查看隐私政策。

Q9：会员价格是多少？
A：月度会员¥12，季度会员¥28，年度会员¥88。新用户首次开通享7天免费试用。

Q10：可以退款吗？
A：会员服务支持购买后48小时内无理由退款。

Q11：为什么收不到验证码？
A：请检查手机信号和短信拦截设置。如果问题持续，联系客服处理。

Q12：支持国际手机号注册吗？
A：目前仅支持中国大陆手机号注册。

Q13：如何成为圈子管理员？
A：在圈子内活跃参与、获得成员认可后，可向现任管理员申请。

Q14：动态可以定时发布吗？
A：会员用户可以使用定时发布功能。

Q15：拉黑用户后对方会知道吗？
A：对方不会收到通知，但可能会发现无法查看你的动态或发送消息。

Q16：雏鸟app有网页版吗？
A：目前以移动端为主，网页版正在开发中。

Q17：如何联系客服？
A：在「我的 > 设置 > 帮助与反馈」中可以联系在线客服。

Q18：账号可以换绑手机号吗？
A：可以，在「账号管理 > 更换手机号」中操作。

Q19：雏鸟app有青少年模式吗？
A：有，在设置中可以开启青少年模式，限制部分功能使用。

Q20：为什么我匹配不到人？
A：请确认已完成兴趣问卷，并检查个人资料的完整度。兴趣数据越丰富，匹配效果越好。`,
    imageSeq: 'article-faq',
    cardImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20illustration%20of%20frequently%20asked%20questions%20with%20question%20marks%20and%20help%20bubbles%20floating%20around%20a%20young%20person%20warm%20coral%20teal%20color%20palette%20clean%20design&width=800&height=500&seq=article-10-card&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20comprehensive%20FAQ%20and%20help%20center%20with%20young%20people%20finding%20answers%20and%20solutions%20warm%20coral%20teal%20amber%20palette%20minimal%20modern%20abstract%20design&width=1200&height=600&seq=article-10-detail&orientation=landscape',
    readCount: 23100,
    publishDate: '2026-07-30',
    author: '雏鸟编辑部',
    relatedArticles: ['article-4', 'article-5', 'article-6'],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};